<template>
  <a-form-item
    :label="data.fieldname"
    class="datetime"
  >
    <div
      v-decorator="[`${data.fieldkey}`, {
        rules: [{
          required: data.isneeded === 1,
          message: placeholder
        }],
        initialValue: defaultValue
      }]"
    >
      <a-date-picker
        :value="defaultValue"
        :placeholder="placeholder"
        :show-time="showTime"
        :format="dateFormat"
        dropdown-class-name="my-data-picker"
        :get-calendar-container="
          triggerNode => {
            return triggerNode.parentNode || document.body;
          }
        "
        :disabled="data.disabled"
        @change="onChange"
        @ok="onOk"
      />

    <!-- <a-date-picker
      v-else
      v-decorator="[`${data.fieldkey}`, {
        rules: [{ required: data.isneeded === 1 ? true : false, message: placeholder }]
      }]"
      :format="dateFormat"
      :show-time="showTime"
      :placeholder="placeholder"
      dropdown-class-name="my-data-picker"
      :get-popup-container="
        triggerNode => {
          return triggerNode.parentNode || document.body;
        }
      "
      :disabled="data.disabled"
      @change="onChange"
      @ok="onOk"
    /> -->
    </div>
  </a-form-item>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DateTime',
  inject: {
    myForm: {
      type: Object,
      default: null
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // dateFormat: 'YYYY-MM-DD',
      // defaultValue: this.data.fieldvalue,
      defaultValue: null
    }
  },
  computed: {
    showTime () {
      const { fieldconfig = {} } = this.data || {}
      const { formatdatetime } = fieldconfig
      if (formatdatetime === 1) {
        return false
      }
      return true
    },
    dateFormat () {
      if (!this.showTime) {
        return 'YYYY-MM-DD'
      } else {
        return 'YYYY-MM-DD HH:mm'
      }
    }
  },
  watch: {
    data: {
      handler (val) {
        if (!val) return
        this.defaultValue = val.fieldvalue ? moment(val.fieldvalue, this.dateFormat) : null
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    /* this.data.fieldvalue = '2015/01/01' */
    this.defaultValue = this.data.fieldvalue ? moment(this.data.fieldvalue, this.dateFormat) : null
    // console.log('defaultValue', this.defaultValue)
  },
  methods: {
    moment,
    init () {
      let { fieldvalue = '' } = this.data || {}
      this.defaultValue = fieldvalue ? moment(fieldvalue, this.dateFormat) : null
    },
    clear () {
      let { fieldkey = '' } = this.data

      // console.log(fieldkey)
      this.myForm && this.myForm.setFieldsValue({
        [fieldkey]: null
      })
    },
    onChange (date, dateString) {
      this.defaultValue = date

      const { fieldkey } = this.data
      this.myForm.setFieldsValue({
        [fieldkey]: this.defaultValue
      })
      this.myForm.validateFields([fieldkey])
      this.$emit('change', dateString)
    },
    onOk (value) {
      this.defaultValue = value
      let dateString = moment(value).format(this.dateFormat)
      this.$emit('change', dateString)
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-calendar-picker {
  width: 320px !important;
}
</style>
<style lang="scss">
.my-data-picker {
  .ant-calendar-time-picker-combobox {
    height: 226px;
    overflow: hidden;
  }
  .ant-calendar-time-picker-column-3 .ant-calendar-time-picker-select {
    width: 50%;
    &:nth-child(2) {
      border: none;
    }
  }
}
</style>
